/** Production API base; avoid baking dev URLs into Lambda bundles. */
function resolveApiBaseUrl(): string {
  const raw = import.meta.env.VITE_API_BASE_URL ?? "/api/v1";
  let s = String(raw).trim().replace(/\/$/, "");
  if (import.meta.env.PROD && /localhost|127\.0\.0\.1/i.test(s)) {
    s = "/api/v1";
  }
  return s || "/api/v1";
}

export const env = {
  apiBaseUrl: resolveApiBaseUrl(),
  useMocks: import.meta.env.VITE_USE_MOCKS === "true",
  enableChampion: import.meta.env.VITE_ENABLE_CHAMPION === "true"
};
